import './src/index.less';
import { withInstall } from '@mts-fe/utils';
import BasicTree from './src/BasicTree.vue';
import _DeptTree from './src/DeptTree.vue';

export { BasicTree };

export const DeptTree = withInstall(_DeptTree);
export * from './src/types/tree';
export type { ContextMenuItem } from '@mts/hooks/web/useContextMenu';
